import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../../../../../shared/gql-client";
import RouteService from "../../../service/routeService";
import { RouteModel } from "../../../../domain/models/routeModel";
import { TruckModel } from "../../../../domain/models/truckModel";
import { changeRouteTruck, PlanningSliceModel } from "../../PlanningSlice";

const routeApi = new RouteService();

export const updatePlanningRouteTruck = createAsyncThunk(
  "planning/update/route/truck",
  async (
    { route, truck }: { route: RouteModel; truck: TruckModel },
    thunkAPI,
  ) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    const { planning } = thunkAPI.getState() as {
      planning: PlanningSliceModel;
    };
    try {
      routeApi.setClient(client);
      void thunkAPI.dispatch(changeRouteTruck({ routeId: route.id, truck }));
      return routeApi.updateRouteTruck(
        route.id,
        truck.id,
        RouteService.getRouteDelta(planning.routes, truck.id),
      );
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const extraReducersUpdatePlanningRouteTruck = (
  builder: ActionReducerMapBuilder<PlanningSliceModel>,
) => {
  builder.addCase(updatePlanningRouteTruck.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(updatePlanningRouteTruck.fulfilled, (state, action) => {
    const updatedRoute = action.payload as RouteModel;
    state.routes = state.routes.map((route) => {
      return route.id === updatedRoute.id ? updatedRoute : route;
    });
  });
};
